import Link from "next/link"
import Image from 'next/image'
import React from "react"
import logoDark from "@images/logoDark.svg"
import logoLight from "@images/logoLight.svg"
import logoWithoutText from "@images/logoWithoutText.svg"

export type NavigationLogoProps = {
  href: string
  title?: string
  theme?: string
  alt?: string
}

export const NavigationLogo = ({ href, title, theme, alt = "Go to the main page" }: NavigationLogoProps) => (
  <Link
    href={href}
    title={title}
    prefetch={false}
  >
    <Image
      unoptimized
      src={(() => {
        switch (theme) {
          case "dark":
          case "neutral":
            return logoLight
          case "light":
            return logoDark
          default:
            return logoWithoutText
        }
      })()}
      alt={alt}
    />
  </Link>
)
